import {
  ModelRepositoryAdapter,
  BaseModel,
  HttpStatus
} from '../../'
import { AppInjector } from '../../helpers'
import { ModelFactory } from '../../../data/factories'
import { GuaranteedFindDecorator } from './'

export class GuaranteedFindDecoratorFactory {
  public constructor(
    private _modelFactory: ModelFactory,
    private _appInjector: AppInjector,
    private _httpStatus: HttpStatus
  ) {}

  public get<T extends ModelRepositoryAdapter<A>, A extends BaseModel = BaseModel>(serviceClass: {new(...args): T}) {
    const service = this._appInjector.get<T>(serviceClass)
    return new GuaranteedFindDecorator<A>(service, this._modelFactory, this._httpStatus)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/guaranteed-find/guaranteed-find-decorator.factory.ts